<template>
  <div class="week-slider-btn">
    <v-btn
      variant="flat"
      rounded="circle"
      height="20"
      width="20"
      color="#dbeafe"
      size="x-small"
      @click="weekRight"
    >
        <svg-icon :svgData="svgData"/>
    </v-btn>
  </div>
</template>
<script>
import SvgIcon from '@/components/content/SvgIcon.vue'
import { useEventsStore } from '@/store/events'

export default {
  name: 'WeekSliderBtnLeft',
  components: {
    SvgIcon
  },
  data () {
    return {
      svgData: {
          width: "5",
          height: "8",
          viewBox: "0 0 5 8",
          pathArr: [{
              d: "M0.105013 6.55016L0.888347 7.3335L4.22168 4.00016L0.888347 0.666829L0.105013 1.45016L2.64946 4.00016L0.105013 6.55016Z",
              fill: "#0075AA"
          }]
      }
    }
  },
  methods:{
    weekRight(){
      let eventsStore = useEventsStore()
      eventsStore.weekRight()
    }
  }
}
</script>